import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Pin, Check } from 'lucide-react';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/boards`;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });

/** "Pin to my dashboard" — drops a Job tile for this WO onto one of the user's boards. */
export default function PinJobButton({ wo, className = '' }) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [boards, setBoards] = useState([]);
  useEffect(() => { if (open) axios.get(API, auth()).then(r => setBoards(r.data.boards || [])).catch(() => {}); }, [open]);
  const pinnedOn = boards.filter(b => Object.values(b.widgets || {}).some(w => w.type === 'job' && w.config?.wo === wo));
  const pin = async (b) => {
    try {
      await axios.post(`${API}/${b.id}/widgets`, { type: 'job', config: { wo }, w: 4, h: 6 }, auth());
      toast.success(`${wo} pinned to ${b.name}`, { action: { label: 'Open board', onClick: () => navigate(`/dashboard/${b.slug}`) } });
      setOpen(false);
    } catch (e) { toast.error(e.response?.data?.detail || 'Could not pin'); }
  };
  return (
    <div className={`relative ${className}`}>
      <button onClick={() => setOpen(o => !o)} title="Pin this job to one of your dashboard boards" data-testid={`pin-job-${wo}`}
        className="inline-flex items-center gap-1.5 px-3 py-2 rounded-lg border border-slate-300 bg-white hover:bg-slate-50 text-slate-700 text-sm font-semibold">
        <Pin className="h-4 w-4" />Pin to dashboard
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-[60]" onClick={() => setOpen(false)} />
          <div className="absolute right-0 top-11 z-[70] w-56 rounded-xl bg-white border border-slate-200 shadow-xl py-1 text-sm" data-testid="pin-job-menu">
            <p className="px-3 py-1.5 text-[10px] uppercase tracking-wider text-slate-400">Add job tile to…</p>
            {boards.map(b => {
              const has = pinnedOn.some(x => x.id === b.id);
              return (
                <button key={b.id} onClick={() => has ? navigate(`/dashboard/${b.slug}`) : pin(b)} className="w-full text-left px-3 py-1.5 hover:bg-blue-50 flex items-center gap-2" data-testid={`pin-job-board-${b.slug}`}>
                  <span className="flex-1 font-semibold text-slate-800">{b.name}</span>
                  {has ? <span className="inline-flex items-center gap-1 text-[11px] text-emerald-700"><Check className="h-3 w-3" />pinned</span> : <span className="text-[11px] text-slate-400">{Object.keys(b.widgets || {}).length} tiles</span>}
                </button>
              );
            })}
            {boards.length === 0 && <p className="px-3 py-2 text-xs text-slate-400">Loading boards…</p>}
          </div>
        </>
      )}
    </div>
  );
}
